const prefix = 'date-range-picker';
export const DateRangePickerTestAttributes = {
    popperRoot: `${prefix}-popper-root`,
    previousMonthButton: `${prefix}-previous-month`,
    nextMonthButton: `${prefix}-next-month`,
};
